import { connect } from 'react-redux';
import { withTranslation  } from 'react-i18next';
import { submit } from 'redux-form';
import * as UserModule from 'Modules/UserModule';
import { IParentDetailsProps } from 'components/Layout/DetailsSidebar/ParentDetails';
import { TerminalInstallationDetails } from 'components/Layout/DetailsSidebar/TerminalInstallationDetails';

interface IP extends IParentDetailsProps {
    edit: boolean;
    match?: any;
}
interface IConnectedP {
    elStore: UserModule.Types.UserStore;
}
interface IDispatchedP {
    t?: (key: string) => string;
    sendFormSubmit: () => void;
}
type S = {};

class TerminalInstallationSetDateDetails extends TerminalInstallationDetails {}

function mapDispachToProps(dispatch: any): IDispatchedP {
    return {
        sendFormSubmit: () => {
            return dispatch(submit('terminalInstallationListSetDateForm'));
        }
    };
}
export default withTranslation (['carDetails', 'forms'])(
    connect(
        null,
        mapDispachToProps
    )(TerminalInstallationSetDateDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/TerminalInstallationSetDateDetails.tsx